const hostApi = process.env.NODE_ENV === "development"
  ? "http://localhost"
  : "https://sing-generator-node.herokuapp.com";
const portApi = process.env.NODE_ENV === "development" ? 8080 : "";
const baseURLApi = `${hostApi}${portApi ? `:${portApi}` : ``}/api`;
const redirectUrl = process.env.NODE_ENV === "development" ? "http://localhost:3000" : "";

export default {
  hostApi,
  portApi,
  baseURLApi,
  redirectUrl,
  remote: "https://sing-generator-node.herokuapp.com",
  isBackend: process.env.REACT_APP_BACKEND,
  auth: {
    // Default admin credentials
    email: 'admin@gmail.com',
    password: 'password',
    
    // Multiple user credentials for different roles
    users: [
      {
        email: 'admin@gmail.com',
        password: 'password',
        role: 'admin',
        firstName: 'Admin User'
      },
      {
        email: 'superadmin@gmail.com',
        password: 'superadmin123',
        role: 'superadmin',
        firstName: 'Superadmin User'
      },
      {
        email: 'employee@gmail.com',
        password: 'employee123',
        role: 'employee',
        firstName: 'Employee User'
      },
      {
        email: 'manager@gmail.com',
        password: 'manager123',
        role: 'manager',
        firstName: 'Manager User'
      },
      {
        email: 'associate@gmail.com',
        password: 'associate123',
        role: 'associate',
        firstName: 'Associate User'
      }
    ]
  },
  app: {
    colors: {
      dark: '#002B49',
      light: '#FFFFFF',
      sea: '#004472',
      sky: '#E9EBEF',
      wave: '#D1E7F6',
      rain: '#CCDDE9',
      middle: '#D7DFE6',
      black: '#13191D',
      salat: '#21AE8C',
    },
  },
};
